import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';

const { EVENT_PRODUCT_INTERACTION } = eventNameConstants;
const { INTERACTION_TYPE_PDP } = interactionTypeConstants;
const { STEP_INTERACTION_FACET_EXPANDED, STEP_INTERACTION_FACET_COLLAPSED } =
    stepInteractionConstants;

const INTERACTION_TYPE_ACCORDION_EXPAND = 'expand';
const INTERACTION_TYPE_ITEM_SPECIFICATIONS = 'item specifications';
const STEP_INTERACTION_DIMENSION_TOGGLE = 'dimension toggle';

const PDP_PRODUCT_CATEGORY = 'product';

/** English GA triggers (MIDFUNNEL-320); not localized. */
export const PDP_ITEM_MODULE_ACCORDION_TRIGGER = {
    itemDescriptionAndSpecifications: 'Item Description & Specifications',
    itemDescription: 'Item Description',
    itemSpecifications: 'Item Specifications',
    sellerInformation: 'Seller Information',
    shippingAndReturns: 'Shipping & Returns',
    customization: 'Customization',
    buyerIncentives: 'The 1stDibs Promise',
} as const;

export function trackPdpAccordionExpand(trigger: string): void {
    trackEvent({
        category: PDP_PRODUCT_CATEGORY,
        action: 'facet expanded',
        label: trigger,
        eventName: EVENT_PRODUCT_INTERACTION,
        interaction_type: INTERACTION_TYPE_ACCORDION_EXPAND,
        step_interaction_name: STEP_INTERACTION_FACET_EXPANDED,
        trigger,
    });
}

export function trackPdpAccordionCollapse(trigger: string): void {
    trackEvent({
        category: PDP_PRODUCT_CATEGORY,
        action: 'facet collapsed',
        label: trigger,
        eventName: EVENT_PRODUCT_INTERACTION,
        interaction_type: INTERACTION_TYPE_PDP,
        step_interaction_name: STEP_INTERACTION_FACET_COLLAPSED,
        trigger,
    });
}

export function trackPdpDimensionToggle(): void {
    trackEvent({
        category: PDP_PRODUCT_CATEGORY,
        action: 'dimension toggle',
        label: 'pdp',
        eventName: EVENT_PRODUCT_INTERACTION,
        interaction_type: INTERACTION_TYPE_ITEM_SPECIFICATIONS,
        step_interaction_name: STEP_INTERACTION_DIMENSION_TOGGLE,
    });
}
